import React, { useState } from 'react';

import { Container } from 'react-bootstrap';

import { Button, SubHeader } from '../../../components';
import useIsMobileScreen from '../../../hooks/useCheckIsMobile';
import './styles.scoped.css';

const MFAValidation = () => {
  const [code, setCode] = useState('');
  // const { cognitoUser } = useSelector(state => state.viewDQF);

  const isMobile = useIsMobileScreen();

  // const params = new URLSearchParams(location.search);
  // const [email, dqf] = [
  //   params.get('email') || '',
  //   params.get('dqf') || '',
  // ];

  // console.log('EMAIL', email);
  // console.log('COGNITO USER?', cognitoUser);

  const handleVerifyCode = async () => {
    if (code) {
      console.log('CODE', code);
      // const resp = await Auth.sendCustomChallengeAnswer(cognitoUser, code);
      // console.log('SMS VALIDATION RESP', resp);
    }
  };

  return (
    <>
      <SubHeader text="Centerline Driver Qualification" />
      <Container className="wrap centered">
        <h2 style={isMobile ? { fontSize: '16px', width: '90%' } : {}} className="title-expiration">
          To safeguard our drivers’ privacy an access code was sent to you via SMS to (+1 XXX-XXX-6022). Please enter
          the code below and click Verify.
        </h2>
        <div className="top-wrapper">
          <div className="enter-code-container">
            <div>Enter Code</div>
            <div className="required-field">*</div>
          </div>
          <input className="input" onChange={e => setCode(e.target.value)} />
          <Button variant="primary" style={{ width: 245, marginTop: 10 }} onPress={() => handleVerifyCode()} text="Verify" />
        </div>
        <h5 className="send-code-text">Didn’t get the code? Click Re-Send to try again</h5>
        <Button variant="neutral" style={{ width: 245 }} text="Re-Send" />
      </Container>
    </>
  );
};

export default MFAValidation;
